import { heroData, siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="hero" className="relative pt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              {heroData.tag}
            </span>

            <h1 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight mb-3">
              {siteInfo.name} · {siteInfo.slogan}
            </h1>

            <p className="text-base md:text-lg text-foreground-700 font-heading mb-4">
              {siteInfo.subSlogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-bold text-primary-600 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {heroData.ctaPrimary}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap border border-background-200"
              >
                {heroData.ctaSecondary}
                <i className="ri-mail-send-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="w-full max-w-md lg:max-w-lg">
              <img
                src={heroData.heroImage}
                alt="51吃瓜网入口 - 吃瓜爆料第一站主视觉"
                className="w-full h-auto rounded-xl object-cover"
                style={{ maxHeight: '420px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}